import { render, staticRenderFns } from "./storeNameList.vue?vue&type=template&id=a1e20708&scoped=true"
import script from "./storeNameList.vue?vue&type=script&lang=js"
export * from "./storeNameList.vue?vue&type=script&lang=js"
import style0 from "./storeNameList.vue?vue&type=style&index=0&id=a1e20708&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e20708",
  null
  
)

export default component.exports